import {
  Bell,
  BellOff,
  Check,
  CheckCircle2,
  ClipboardList,
  Edit,
  Link2,
  MapPin,
  MessageSquare,
  Paperclip,
  Plus,
  Settings,
  X,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Shared icon lookup for common timeline event types.
 * Domain-specific callers can spread this record and override or extend it.
 */
export const timelineIcons = {
  // Messages / notes
  ADD_MESSAGE: MessageSquare,
  UPDATE_MESSAGE: MessageSquare,
  ADD_NOTE: MessageSquare,
  EDIT_NOTE: MessageSquare,
  REMOVE_NOTE: MessageSquare,

  // Attachments
  ADD_ATTACHMENT: Paperclip,
  REMOVE_ATTACHEMNT: Paperclip, // legacy typo preserved from models

  // Locations / geotags
  ADD_LOCATION: MapPin,
  UPDATE_LOCATION: MapPin,
  ADD_GEOTAG: MapPin,
  EDIT_GEOTAG: MapPin,
  REMOVE_GEOTAG: MapPin,

  // Edits / patches
  PATCH: Edit,
  UPDATE_TICKET: Edit,

  // Creation
  CREATE_TICKET: Plus,
  CREATE_LIST: ClipboardList,

  // Status
  CLOSE_LIST: ClipboardList,
  OPEN_LIST: ClipboardList,

  // Notifications
  NOTIFICATION_OPT_IN: Bell,
  NOTIFICATION_OPT_OUT: BellOff,

  // References
  TICKET_REFERENCE: Link2,

  // Template
  EXPAND_PROTO: Settings,
} as const satisfies Record<string, LucideIcon>;

/** Default icon when no match is found */
export const DEFAULT_TIMELINE_ICON = CheckCircle2;

/**
 * Look up a timeline event icon by type string.
 * Returns a sensible default for unknown types.
 */
export function getTimelineIcon(
  type: string,
  overrides?: Record<string, LucideIcon>,
): LucideIcon {
  if (overrides && type in overrides) {
    return overrides[type];
  }
  return (
    (timelineIcons as Record<string, LucideIcon>)[type] ?? DEFAULT_TIMELINE_ICON
  );
}

// Re-export common icons used by domain-specific aggregated events
// so callers don't need to import from lucide-react separately.
export { Check, X } from 'lucide-react';
